module.exports = __webpack_public_path__ + "img/Symbol_8.479d5ff1.png";